import { Button } from "@/components/common/Button";
import Modal from "@/components/common/Modal";
import { useTranslation } from "react-i18next";

type Props = {
  onClose: () => void;
};

const RefcodeReopen = ({ onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal title={""} onClose={onClose}>
      <div className="w-full flex flex-col items-center p-8 gap-6">
        <div className="flex flex-col items-center gap-1 text-center">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint -tracking-[0.025rem]">
            {t("main-page.modal.reopen")}
          </p>
        </div>

        <Button
          onClick={onClose}
          text={t("main-page.modal.close")}
          size="large"
          className="w-full"
        />
      </div>
    </Modal>
  );
};

export default RefcodeReopen;
